import { Component, OnInit } from '@angular/core';
import jspdf, { ImageOptions } from 'jspdf';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from 'src/app/shared/services/firebase.service';
import { HttpClient } from "@angular/common/http";
import { pipe } from "rxjs";
import { map } from "rxjs/operators";
import { DomSanitizer } from '@angular/platform-browser';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'certificado',
  templateUrl: './certificado.component.html',
  styleUrls: ['./certificado.component.css']
})
export class CertificadoComponent implements OnInit {

  title = 'ngsdfsdf';
  imgCurso: string = "assets/images/cursos/curso1.jpg"
  backCertificado: string = "assets/images/certificado/certificado.png"
  firmaCEO: string = "assets/images/certificado/firma-ceo.png"
  

  constructor(
    private route: ActivatedRoute,
    public fb: FormBuilder,
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private functions: AngularFireFunctions,
  ) { }

  id = this.route.snapshot.paramMap.get('id');
  curso: any;

  // Carga de datos
  loaded = 0;

  // datos certificado
  nombreUsuario;
  tituloCurso;
  descripcionCurso;
  nombreInstructor;
  horas: string = 'hora';
  imgTest;
  empresaNombre: string;

  fecha: Date;
  fechaTransformada;
  firmaInstructor;
  logoEmpresa;
  duracionCurso;

  options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

  imgfirmaInstructor = new Image(15,40)
  imgLogoEmpresa = new Image(20,20)


  ngOnInit(): void {
    this.obtenerCertificado();
  }


  obtenerCertificado() {
    this.afs.collection('usuariosCertificados').doc(this.id).ref.get().then(snap => {
      const data = snap.data();
      this.fechaTransformada = snap.data()['fecha'].toDate();
      this.fechaTransformada = this.fechaTransformada.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      let usuarioId = data['usuarioId'];
      const cursoId = data['cursoId'];
      this.nombreUsuario = data["usuarioNombre"];
      this.afs.collection('cursos').doc(cursoId).ref.get().then(snap => {
        console.log('entre a curso')
        const dataCurso = snap.data();
        this.tituloCurso = dataCurso['titulo'];
        this.descripcionCurso = dataCurso['resumen']
        this.nombreInstructor = dataCurso['instructorNombre'];
        this.duracionCurso = Math.ceil(dataCurso['duracion']/60).toFixed(0)
        if (this.duracionCurso >= 2) {this.horas = 'horas'}
        const instructorId = dataCurso['instructorId'];
        console.log(instructorId)
        this.afs.collection('instructores').doc(instructorId).ref.get().then(snap => {
          console.log('entre a instructor')
          const dataInstructor = snap.data()
          this.loaded = 1;
          this.firmaInstructor = dataInstructor['firma'];
          this.logoEmpresa = dataInstructor['empresaFoto'];
          this.empresaNombre = dataInstructor['empresaNombre'];
          this.imgfirmaInstructor.src = this.firmaInstructor;
          this.imgLogoEmpresa.src = this.logoEmpresa;
        }).catch(error => {
          console.log(error)
        })
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })
  }

  async downloadPDF() {
    var doc = new jspdf('l', 'mm', [297, 210]);

    doc.addImage(this.backCertificado, 'PNG', 0, 0, 297, 210)
    doc.setFontSize(27)
    doc.setTextColor(21, 27, 38)
    doc.setFont('helvetica', 'bold')
    doc.text(this.nombreUsuario, 19, 80) // Nombre usuario

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(13)
    doc.setTextColor(156, 166, 175)
    doc.text('Por completar exitosamente el curso en línea con duración de ' + this.duracionCurso + ' ' + this.horas , 19, 91) // Nombre usuario
    doc.setFontSize(19)
    doc.setTextColor(100, 111, 121)
    var tituloCurso = doc.splitTextToSize(this.tituloCurso, 170)
    doc.text(tituloCurso, 19, 101) // Nombre usuario

    doc.setFontSize(15)
    if (this.empresaNombre){
      doc.text(this.empresaNombre, 19, 48) // Nombre usuario
      doc.addImage({imageData: this.imgLogoEmpresa, x: 17, y:10, width: 30, height: 30,} as ImageOptions)
    }



    doc.setFontSize(12)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(132, 143, 153)
    // doc.text(this.nombreInstructor, 19, 158) // Nombre usuario
    doc.addImage(this.firmaCEO, 'PNG', 12, 136, 80, 30)
    doc.text('Andrés Enrique González Giraldo', 19, 168) // Nombre usuario
    doc.setFont('helvetica', 'normal')
    doc.text('Instructor: ' + this.nombreInstructor, 19, 126) // Nombre instructor

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(13)
    // doc.setFontType('bold')
    // doc.text('Instructor', 19, 165) // Nombre usuario
    doc.text('CEO de Predyc', 19, 175) // Nombre usuario

    doc.setFontSize(15)
    doc.text(this.fechaTransformada, 19, 190) // Nombre usuario

    doc.setFontSize(11)
    doc.text('Certificado por Predyc. Código de certificado: ' + this.id, 19, 197) // Nombre usuario

    // doc.text('David Alejandro Garcia Lopez', 230, 10) // Nombre usuario

    doc.save('certificado.pdf')
  }
}

